import React from 'react'

import Header from '../../components/Header'

import { Container, Content, Line } from './styles'

const Finish: React.FC = () => {
  return (
    <>
      <Header />
      <Container>
        <Content>
          <strong>Agradecemos pelo interesse em nosso Plano.</strong>

          <Line />

          <strong>Para mais informações, entre em contato conosco:</strong>
          <div>
            <div>
              <p>Telefone: </p>
              {/* <span>0800 702-1210</span> */}
              <span> (27) 3348-1214</span>
            </div>

            <div>
              <p>Site: </p>
              <span>
                <a href="https://aspprev.tubarao.com.br/aspprevonline/?">
                  www.aspprev.com.br
                </a>
              </span>
            </div>
          </div>
        </Content>
      </Container>
    </>
  )
}

export default Finish
